// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1R9PR","cell":"ColumnAccessor_cell__22eCC","firstCellAccent":"ColumnAccessor_firstCellAccent__3faTh"};